import { Component, Input, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { LocationContactCardComponent } from './location-contact-card.component';

@Component({
  selector: 'address-card',
  templateUrl: 'address-card.component.html'
})
export class AddressCardComponent {
  @Input() contactCard: any;
  @Input() iconType: string;
  @ViewChild(OverlayPanel) overlayPanel: OverlayPanel;
  @ViewChild(LocationContactCardComponent)
  locationContactCardComponent: LocationContactCardComponent;

  public isShow: boolean;
  private isMouseOnContactCard: boolean;

  showContactCard(event, target) {
    this.isShow = true;
    setTimeout(() => {
      if (this.isShow && !!this.contactCard && this.contactCard !== undefined && this.contactCard.City != '') {
        this.overlayPanel.show(event, target);
        this.locationContactCardComponent.refreshMap();
      }
    }, 1000);
  }

  hideContactCard() {
    setTimeout(() => {
      if (!this.isMouseOnContactCard) {
        this.isShow = false;
        if (!!this.overlayPanel) this.overlayPanel.hide();
      }
    }, 500);
  }

  onMouseLeavedCard() {
    this.isMouseOnContactCard = false;
    this.hideContactCard();
  }
  onMouseOverCard() {
    this.isMouseOnContactCard = true;
  }
}
